// extracted by mini-css-extract-plugin
export default {"White":"#FFFFFF","menuDateRange":"Gb307aa G5ceaa3 G81a5ae Ga369ba Gd1723b G13b379","mobile":"Ge35d81 Gd99ee9"};